//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isUndefined, isEqual, map, find, isNull, replace, clone } from 'lodash'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
//////COMPONENTS//////
import { itemCatalogActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import theme from '../../theme/theme'
import ModalSaleByCode from './ModalSaleByCode/ModalSaleByCode'
import { uriList } from '../../routings/settings/RouteList'
import Table from '../../components/Table'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import Tooltip from '../../components/Tooltip/Tooltip'
import TableTitle from '../../components/Table/components/TableTitle'
import convertHexToRGBA from '../../helpers/HexToRgba'
//////ASSETS//////
import SalesByCodeIcon from '../../assets/icones/itemCatalog/chart-view.svg'
import noImage from '../../assets/icones/global/no-picture.svg'

//////STYLED//////
const ItemCatalogWrapper = styled.div`
	position: relative;
`
const TextModalWrapper = styled.div`
	width: 100%;
	height: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`
const SalesHistoryByCodeButton = styled(Link)`
	width: 32px;
	height: 32px;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	background-image: url(${SalesByCodeIcon});
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
	background-size: 24px auto;
`
const ItemCatalogListWrapper = styled.div`
	display: grid;
	grid-template-columns: minmax(0px, 424px) minmax(0px, 424px) minmax(0px, 424px) minmax(0px, 424px);
	grid-column-gap: 32px;
	grid-row-gap: 32px;
	margin-bottom: 50px;
`
const ItemCatalogCard = styled.div`
	max-width: 404px;
	height: 320px;
	border: 1px solid ${(props) => props.theme.colors.card.border};
	padding: 10px;
`
const ItemCatalogCardInfoWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	vertical-align: middle;
	grid-row-gap: 30px;
	height: 100%;
	position: relative;
	& > div {
		width: 50%;
	}
	& > div > img {
		height: auto;
		max-height: 100%;
		max-width: calc(100% - 20px);
		margin: auto;
	}
`
const ItemCatalogCardInfos = styled.div`
	display: grid;
	flex-direction: column;
	grid-row-gap: 10px;
	width: 50%;
	font-size: ${(props) => props.theme.font.fm};
	height: 100%;
	grid-auto-rows: max-content;
	line-height: normal;
	overflow-y: auto;
`
const ItemCatalogCardInfosBrand = styled.span`
	color: ${(props) => props.theme.colors.primary};
	font-weight: bold;
`
const ItemCatalogCardInfosLabel = styled.span`
	font-weight: bold;
`
const ItemCatalogCardInfosSpecs = styled.div`
	& span {
		display: block;
		line-height: normal;
	}
	& span:first-child {
		text-decoration: underline;
	}
`
const ItemCatalogCardInfosStandardPrice = styled.div`
	& > span:first-child {
		background-color: ${(props) => convertHexToRGBA(props.theme.colors.primary, 0.2)};
		color: ${(props) => props.theme.colors.primary};
		width: fit-content;
		border-radius: 15px;
		margin: 0 auto;
		font-weight: bold;
		padding: 0px 10px;
		line-height: 25px;
		display: inline-block;
	}
	& > span + span {
		margin-left: 10px;
		text-decoration-line: line-through;
	}
`
const ItemCatalogCardInfosDepositPrice = styled.div`
	& span {
		display: block;
		line-height: normal;
		width: fit-content;
		color: ${theme.colors.primary};
	}
	& > span:last-child {
		border-radius: 15px;
		color: ${(props) => props.theme.colors.primary};
		margin: auto auto auto 0px;
		border: 1px solid ${(props) => props.theme.colors.primary};
		display: inline-block;
		font-weight: bold;
		padding: 0px 10px;
		line-height: 25px;
	}
`
const ItemCatalogStock = styled.span`
	background-color: ${(props) => convertHexToRGBA(props.stockColor, 0.2)};
	color: ${(props) => props.stockColor};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
	position: absolute;
	bottom: 0px;
	left: 0px;
	padding: 0px 10px;
	line-height: 25px;
`
const ItemCatalogPromo = styled.div`
	background-color: ${(props) => convertHexToRGBA(props.theme.colors.card.promoColor, 0.2)};
	color: ${(props) => props.theme.colors.card.promoColor};
	position: absolute;
	top: 0px;
	border-radius: 15px;
	width: fit-content;
	font-weight: bold;
	left: 0px;
	padding: 0px 10px;
	line-height: 25px;
`
const ItemCatalogCardActions = styled.div`
	position: absolute;
	bottom: 0px;
	right: 0px;
`
//////STYLED//////

const ItemCatalog = () => {
	const { user, translations, userKioskPerimeter, itemCatalog, userRolePrivileges, itemCatalogFilters, item, isSearchfieldUpdated } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			userKioskPerimeter: state.user.identity.kioskSelected,
			itemCatalog: state.itemCatalog,
			userRolePrivileges: state.user.identity.rolePrivileges,
			itemCatalogFilters: state.itemCatalog.header,
			item: state.itemCatalog.item,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
		}),
		shallowEqual
	)

	const [swytch, setSwytch] = useState(false)

	const history = useHistory()

	// Modals
	const [row, setRow] = useState()
	//const [showModalSimCard, setShowModalSimCard] = useState(true)+
	const [showSaleByCodeModal, setShowSaleByCodeModal] = useState(false)

	// Paging
	//const [paging, setPaging] = useState({ page: '0', size: '50' })
	const [paging, setPaging] = useState()

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})

	// Columns
	const [columns, setColumns] = useState([])

	const handleSubmitRadioClose = (newFilters, target) => {
		// We want to use changed filters, not waiting for useEffect (sort of force method)
		// With kiosks filters, target will determine primacy of filters, which one is impacting the other on 'active' field
		let mergedArray = map(newFilters.filtersSelection.kiosks.filterElements, (elem, k) => {
			if (target === 'customerKiosks') {
				elem.active = newFilters.filtersSelection.customerKiosks.filterElements[k].active
			}
			return elem
		})

		newFilters.filtersSelection.kiosks.filterElements = mergedArray
		newFilters.filtersSelection.kiosks.updated = true

		const filt = {
			...newFilters,
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '50',
				sort: !toggleSort ? 'name' : 'price',
				order: toggleOrder ? 'desc' : 'asc',
			}
		} else {
			pg.page = '0'
			pg.sort = !toggleSort ? 'name' : 'price'
			pg.order = toggleOrder ? 'desc' : 'asc'
		}
		setPaging(pg)

		actionsItemCatalog.getItemCatalog(filt, pg)
	}

	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter, handleSubmitRadioClose)

	const [toggleOrder, setToggleOrder] = useState(false)
	const [toggleSort, setToggleSort] = useState(false)

	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	// Kiosk code for title
	const [kioskCode, setKioskCode] = useState('')
	//To set target for sale by code modal
	const [target, setTarget] = useState(null)
	const actionsItemCatalog = bindActionCreators(itemCatalogActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingItemCatalog = (paging) => {
		setPaging(paging)
		actionsItemCatalog.getItemCatalog(handleFilterSend(), paging)
	}

	// handler search bar
	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = (filterKiosks = false) => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '50',
				sort: !toggleSort ? 'name' : 'price',
				order: toggleOrder ? 'desc' : 'asc',
			}
		} else {
			pg.page = '0'
			pg.sort = !toggleSort ? 'name' : 'price'
			pg.order = toggleOrder ? 'desc' : 'asc'
		}
		setPaging(pg)

		actionsItemCatalog.getItemCatalog(handleFilterSend(filterKiosks), pg)
	}

	const handleFilterSend = (_filterKiosks = false) => {
		// Merging kiosks and customerKiosks filters only for request
		const currentFilters = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		// Spread method doesn't work, neither merge method
		// We are doing it manually then ?
		// const mergedArray = [
		// 	...currentFilters.filtersSelection.customerKiosks.filterElements,
		// 	...currentFilters.filtersSelection.kiosks.filterElements,
		// ]
		filtersOut = { ...searchFieldUpdated, ...currentFilters }
		return {
			...filtersOut,
			withFilters: true,
			userKioskScope: {
				kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
			},
		}
	}

	const handleCloseSaleByCodeModal = () => {
		setShowSaleByCodeModal(false)
	}
	const handleToggleSort = () => {
		let valSort = clone(toggleSort)
		valSort = !valSort

		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '50',
				sort: valSort === false ? 'name' : 'price',
				order: toggleOrder === true ? 'desc' : 'asc',
			}
		} else {
			pg.page = '0'
			pg.sort = valSort === false ? 'name' : 'price'
			pg.order = toggleOrder === true ? 'desc' : 'asc'
		}
		setPaging(pg)
		actionsItemCatalog.getItemCatalog(handleFilterSend(), pg)
		setToggleSort(valSort)
	}

	const handleToggleOrder = () => {
		let valOrder = clone(toggleOrder)
		valOrder = !valOrder

		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '50',
				sort: toggleSort === false ? 'name' : 'price',
				order: valOrder === true ? 'desc' : 'asc',
			}
		} else {
			pg.page = '0'
			pg.sort = toggleSort === false ? 'name' : 'price'
			pg.order = valOrder === true ? 'desc' : 'asc'
		}
		setPaging(pg)
		actionsItemCatalog.getItemCatalog(handleFilterSend(), pg)
		setToggleOrder(valOrder)
	}

	const handleSeeSale = (row) => {
		// We pass item label to sales history manager search bar
		// But method might change
		actionsItemCatalog.setSaleByArticle(row)
		history.push(`${uriList.sales}${uriList.salesByArticleHistory}`)
	}
	const handleSeeSalesCode = (row) => {
		actionsItemCatalog.setSalesByCodeArticle(row)
		history.push(`${uriList.sales}${uriList.salesHistoryByCodes}`)
	}
	const handleSeeStocks = (row) => {
		let modifiedRow = cloneDeep(row)
		// Adding kiosk manufacturer code to our row
		const f = find(filters.filtersSelection.kiosks.filterElements, { active: true })
		modifiedRow.codeKioskManufacturer = f.manufacturerKioskCode
		const f2 = find(filters.filtersSelection.customerKiosks.filterElements, { active: true })
		modifiedRow.codeKioskCustomer = f2.customerKioskCode

		actionsItemCatalog.getStocksFiltersInfo(modifiedRow)
		history.push(`${uriList.recapStock}`)
	}
	const handleSeeItemDetails = (row) => {
		history.push(`${uriList.itemCatalog}${uriList.itemCatalogDetail}/${row.id}`)
	}

	const handleGenerateSaleByCode = (target, catalogItem) => {
		setTarget(target)
		setRow(catalogItem)
		setShowSaleByCodeModal(true)
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	const [configTableTitle, setConfig] = useState({
		name: '',
		paging: {},
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
		},
	})

	const [configTable, setconfigTable] = useState({
		pageActions: [
			{
				component: () => {
					return (
						<Tooltip tooltipId={'salesHistoryByCodeButton'} translationsKey={'tooltip__admin__itemCatalog__kiosk_codeHistory'}>
							<SalesHistoryByCodeButton to={`${uriList.sales}${uriList.salesHistoryByCodes}`} />
						</Tooltip>
					)
				},
			},
		],
	})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		if (showSaleByCodeModal && row) {
			actionsItemCatalog.getSaleOrderByCode(row.id)
		}
	}, [showSaleByCodeModal, row])

	useEffect(() => {
		return function cleanUp() {
			actionsItemCatalog.resetDataItemCatalog()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}
		setConfig(cfg)
	}, [searchValue])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		setFilters(itemCatalogFilters)
		setPrevFilter(itemCatalogFilters)
	}, [translations, itemCatalogFilters])

	// On updating sorts, updating render also
	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.actions.sortLists = [
			() => <ToggleFilters checked={toggleOrder} onChangeHandler={handleToggleOrder} name="toggleOrder" sortPics />,
			() => (
				<ToggleFilters
					checked={toggleSort}
					onChangeHandler={handleToggleSort}
					name="toggleSort"
					labelPrev={translations['page__itemCatalog__kiosk__sort_name']}
					labelNext={translations['page__itemCatalog__kiosk__sort_order']}
				/>
			),
		]
		setConfig(cfg)
	}, [toggleOrder, toggleSort])

	// On updating filters, updating render also
	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.name = `${translations['page__itemCatalog__kiosk__page_title']} ${kioskCode}`

		cfg.actions.sortLists = [
			() => <ToggleFilters checked={toggleOrder} onChangeHandler={handleToggleOrder} name="toggleOrder" sortPics reverseCheck />,
			() => (
				<ToggleFilters
					checked={toggleSort}
					onChangeHandler={handleToggleSort}
					name="toggleSort"
					labelPrev={translations['page__itemCatalog__kiosk__sort_name']}
					labelNext={translations['page__itemCatalog__kiosk__sort_order']}
				/>
			),
		]

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__itemCatalog__kiosk__filter_brand']}
					data={filters.filtersSelection?.brands.filterElements || []}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'brands'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__itemCatalog__kiosk__filter_family']}
					data={filters.filtersSelection?.families.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'families'}
					radio
				/>
			),

			() => (
				<DropdownCheckbox
					title={translations['page__itemCatalog__kiosk__filter_distributor']}
					data={filters.filtersSelection?.distributors.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'distributors'}
					radio
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__itemCatalog__kiosk__filter_kioskCode']}
					data={filters.filtersSelection?.kiosks.filterElements || []}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={() => handleSubmit(true)}
					target={'kiosks'}
					radio
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__itemCatalog__kiosk__filter_customerKioskCode']}
					data={filters.filtersSelection?.customerKiosks.filterElements || []}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={() => handleSubmit(true)}
					target={'customerKiosks'}
					radio
				/>
			),
		]

		setConfig(cfg)
	}, [filters, translations])

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			const filtersCp = {
				withFilters: searchValue?.length > 0 ? true : false,
				filtersSelection: null,
				searchField: filters.searchField,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
				searchFieldUpdated: false,
			}
			actionsItemCatalog.getItemCatalog(filtersCp)
			setFilters(filtersCp)
		}
	}, [swytch, translations])

	//In case of close generate code modal we need to make call to update item
	useEffect(() => {
		if (itemCatalog.isClosedModal) {
			const filtersCp = {
				withFilters: searchValue?.length > 0 ? true : false,
				filtersSelection: null,
				searchField: filters.searchField,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			}
			actionsItemCatalog.getItemCatalog(filtersCp)
			setFilters(filtersCp)
		}
	}, [itemCatalog.isClosedModal])

	//When we finish process we have to make new call to refresh data, should be optim by receive item row
	useEffect(() => {
		if (itemCatalog.toUpdated) {
			const filtersCp = {
				withFilters: searchValue?.length > 0 ? true : false,
				filtersSelection: null,
				searchField: filters.searchField,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			}
			actionsItemCatalog.getItemCatalog(filtersCp)
			setFilters(filtersCp)
		}
	}, [itemCatalog.toUpdated])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (
			!isEqual(userKioskPerimeter, currentPerimeterKiosks) &&
			!isEmpty(currentPerimeterKiosks) &&
			!isUndefined(user.identity.kioskSelected) &&
			!isUndefined(user.identity.kioskSelected[0].id)
		)
			// we need to set with filter to false to update our kiosk perimeter if we change it
			actionsItemCatalog.getItemCatalog(
				{
					withFilters: false,
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
				},
				paging
			)
		setCurrentPerimeterKiosks(userKioskPerimeter)
	}, [userKioskPerimeter])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(itemCatalog) && !isUndefined(itemCatalog)) {
			cfg.paging = {
				totalElements: itemCatalog.paging.totalElements,
				totalPages: itemCatalog.paging.totalPages,
				fnSendTo: (paging) => handlePagingItemCatalog(paging),
			}
			cfg.noColumnFilter = true
			setConfig(cfg)
		}
	}, [itemCatalog])

	// To set kiosk code par in page title
	useEffect(() => {
		if (!isUndefined(itemCatalog.header.filtersSelection)) {
			map(itemCatalog.header.filtersSelection.customerKiosks?.filterElements, (elem, _key) => {
				if (elem.active) setKioskCode(elem.customerKioskCode)
			})
		}
	}, [itemCatalog.header.filtersSelection])

	const TableRender = useMemo(() => {
		return (
			<Table
				//inputColumns={columns}
				inputData={itemCatalog.items}
				isLoading={itemCatalog.isLoading}
				inputConfig={configTable}
			/>
		)
	}, [itemCatalog, columns, configTable, translations])

	/*
	{
		"0": {
			"id": 207,
			"kioskCapacity": 6,
			"lockerStock": 1,
			"stockAlert": 1,
			"currency": {
				"symbol": "€"
			},
			"standardPrice": 19.75,
			"depositPrice": 25,
			"withDeposit": true,
			"promoPrice": null,
			"promoDeposit": null,
			"brand": "Primagaz",
			"label": "Bio Twiny butane 6kg 51% biogaz",
			"shortDescription": "",
			"dimension": "Hauteur 31 cm / Diamètre 31 cm",
			"weight": "13 kg à plein, dont 6 kg de gaz propane",
			"stackable": "Oui",
			"picture": "public_src/item/pictures/PRI_BUT_6KG.png",
			"promo": false
		}
	}
	*/

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			<ItemCatalogWrapper>
				<Table currentPaging={paging} inputConfig={configTable} isLoading={itemCatalog.isLoading} isPaging={false} />
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} isLoading={itemCatalog.isLoading} isSortColumns={false} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
				{
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<ItemCatalogListWrapper>
							{translations &&
								map(itemCatalog.items, (catalogItem, _k) => {
									let stockColor
									let usedLabel
									if (catalogItem.lockerStock === 0) {
										stockColor = theme.colors.error
										usedLabel = translations['page__itemCatalog__kiosk__sticker_soldOut']
									} else if (catalogItem.lockerStock <= catalogItem.stockAlert) {
										stockColor = theme.colors.warning
										usedLabel = translations['page__itemCatalog__kiosk__sticker_inStock']
									} else {
										stockColor = theme.colors.validation
										usedLabel = translations['page__itemCatalog__kiosk__sticker_inStock']
									}
									return (
										<ItemCatalogCard>
											<ItemCatalogCardInfoWrapper>
												<div>
													{catalogItem.promo && (
														<ItemCatalogPromo>{translations['page__itemCatalog__kiosk__sticker_promo']}</ItemCatalogPromo>
													)}
													<ItemCatalogStock stockColor={stockColor}>
														{usedLabel} {catalogItem.lockerStock} / {catalogItem.kioskCapacity}
													</ItemCatalogStock>
													<img src={isNull(catalogItem.picture) ? noImage : `/${catalogItem.picture}`} />
												</div>
												<ItemCatalogCardInfos>
													<ItemCatalogCardInfosBrand>{catalogItem.brand}</ItemCatalogCardInfosBrand>
													<ItemCatalogCardInfosLabel>{catalogItem.label}</ItemCatalogCardInfosLabel>
													{!isNull(catalogItem.shortDescription) && catalogItem.shortDescription.length > 0 && (
														<span>{catalogItem.shortDescription}</span>
													)}
													<ItemCatalogCardInfosStandardPrice>
														<span>
															{replace(
																catalogItem.promo && !isNull(catalogItem.promoPrice)
																	? catalogItem.promoPrice.toFixed(2)
																	: catalogItem.standardPrice.toFixed(2),
																'.',
																','
															)}
															{catalogItem.currency.symbol}
														</span>
														{catalogItem.promo && (
															<span>
																{replace(catalogItem.standardPrice.toFixed(2), '.', ',')}
																{catalogItem.currency.symbol}
															</span>
														)}
													</ItemCatalogCardInfosStandardPrice>

													{!isNull(catalogItem.dimension) && catalogItem.dimension.length > 0 && (
														<ItemCatalogCardInfosSpecs>
															<span>{translations['page__itemCatalog__kiosk__field_dimension']} :</span>
															<span>{catalogItem.dimension}</span>
														</ItemCatalogCardInfosSpecs>
													)}
													{!isNull(catalogItem.weight) && catalogItem.weight.length > 0 && (
														<ItemCatalogCardInfosSpecs>
															<span>{translations['page__itemCatalog__kiosk__field_weight']} :</span>
															<span>{catalogItem.weight}</span>
														</ItemCatalogCardInfosSpecs>
													)}
													{!isNull(catalogItem.stackable) && catalogItem.stackable.length > 0 && (
														<ItemCatalogCardInfosSpecs>
															<span>{translations['page__itemCatalog__kiosk__field_stackable']} :</span>
															<span>{catalogItem.stackable}</span>
														</ItemCatalogCardInfosSpecs>
													)}
													{catalogItem.withDeposit && (
														<ItemCatalogCardInfosDepositPrice>
															<span>{translations['page__itemCatalog__kiosk__field_deposit']} :</span>
															<span>
																{!isNull(catalogItem.depositPrice) &&
																	replace(catalogItem.depositPrice.toFixed(2), '.', ',')}
																{catalogItem.currency.symbol}
															</span>
														</ItemCatalogCardInfosDepositPrice>
													)}
													<ItemCatalogCardActions>
														<ActionsTable
															forceActionsList
															paperActionsList={[
																{
																	name: translations['page__itemCatalog__kiosk__action_seeDetails'],
																	translationKey: 'page__itemCatalog__kiosk__action_seeDetails',
																	clickAction: () => {
																		handleSeeItemDetails(catalogItem)
																	},
																	isVisible: () =>
																		!isUndefined(
																			find(
																				userRolePrivileges.privileges,
																				(o) => o.label === userPrivileges.view[10]
																			)
																		),
																},
																{
																	name: translations[
																		'page__itemCatalogue__itemCard_actionModal_button_generateSaleCode'
																	],
																	translationKey:
																		'page__itemCatalogue__itemCard_actionModal_button_generateSaleCode',
																	clickAction: () => {
																		handleGenerateSaleByCode('sale', catalogItem)
																	},
																	isVisible: () =>
																		!isUndefined(
																			find(
																				userRolePrivileges.privileges,
																				(o) => o.label === userPrivileges.action[24]
																			)
																		) && catalogItem.lockerStock > 0,
																},
																{
																	name: translations[
																		'page__itemCatalogue__itemCard_actionModal_button_generateExchangeCode'
																	],
																	translationKey:
																		'page__itemCatalogue__itemCard_actionModal_button_generateExchangeCode',
																	clickAction: () => {
																		handleGenerateSaleByCode('exchange', catalogItem)
																	},
																	isVisible: () =>
																		!isUndefined(
																			find(
																				userRolePrivileges.privileges,
																				(o) => o.label === userPrivileges.action[24]
																			)
																		) && catalogItem.lockerStock > 0,
																},
																{
																	name: translations['page__itemCatalog__kiosk__action_codeHistory'],
																	translationKey: 'page__itemCatalog__kiosk__action_codeHistory',
																	clickAction: () => {
																		handleSeeSalesCode(catalogItem)
																	},
																	isVisible: () =>
																		!isUndefined(
																			find(
																				userRolePrivileges.privileges,
																				(o) => o.label === userPrivileges.view[10]
																			)
																		),
																},
																{
																	name: translations['page__itemCatalog__kiosk__action_itemSales'],
																	translationKey: 'page__itemCatalog__kiosk__action_itemSales',
																	clickAction: () => {
																		handleSeeSale(catalogItem)
																	},
																	isVisible: () =>
																		!isUndefined(
																			find(
																				userRolePrivileges.privileges,
																				(o) => o.label === userPrivileges.view[6]
																			)
																		),
																},
																{
																	name: translations['page__itemCatalog__kiosk__action_itemStock'],
																	translationKey: 'page__itemCatalog__kiosk__action_itemStock',
																	clickAction: () => {
																		handleSeeStocks(catalogItem)
																	},
																	isVisible: () => {
																		return !isUndefined(
																			find(
																				userRolePrivileges.privileges,
																				(o) => o.label === userPrivileges.view[15]
																			)
																		)
																	},
																},
															]}
															column={{ tooltipPart: 'itemCatalog' }}
														/>
														{/*
														rest: {
				tooltipPart: 'salesHistoryManager',
				paperActionsList: [
					{
						name: translations['tooltip__admin__global__action__consignmentContract_detail'],
						translationKey: 'tooltip__admin__global__action__consignmentContract_detail',
						clickAction: (row) => {
							handleSeeConsignation(row)
						},
						isVisible: (row) =>
							row.salesOrderType?.id === 1 &&
							row.withDeposit === true &&
							!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[11])),
						iconDef: badge,
					},
					{
						name: translations['tooltip__admin__global__action__salesTicket_detail'],
						translationKey: 'tooltip__admin__global__action__salesTicket_detail',
						clickAction: (row) => {
							handleModalTicket(row)
						},
						isVisible: (row) => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[9])),
						iconDef: group,
					},
					{
						name: translations['tooltip__admin__global__action__paymentCollection_detail'],
						translationKey: 'tooltip__admin__global__action__paymentCollection_detail',
						clickAction: (row) => {
							handleSeeTelecollect(row)
						},
						isVisible: (row) =>
							!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[13])) &&
							!isNull(row.paymentCollectionId),
						icon: eye,
					},
					{
						name: translations['page__transactionsHistory__admin__customerTicket_detail_tableAction_sendTicket'],
						translationKey: 'tooltip__admin__global__action__customerTicket_detail',
						clickAction: (row) => {
							handleGuestTicketModal(row)
						},
						isVisible: (row) =>
							!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[33])) &&
							row.canSendCustomerTicketByEmail,
						icon: guestTicket,
					},
				],
			},
													*/}
													</ItemCatalogCardActions>
												</ItemCatalogCardInfos>
											</ItemCatalogCardInfoWrapper>
										</ItemCatalogCard>
									)
								})}
						</ItemCatalogListWrapper>
					</div>
				}
			</ItemCatalogWrapper>
			{/* Modal Sale By Code */}
			{!isEqual(item, {}) && (
				<ModalSaleByCode
					target={target}
					item={item}
					closeModal={handleCloseSaleByCodeModal}
					showModal={showSaleByCodeModal}
				></ModalSaleByCode>
			)}
		</Fragment>
	)
}

ItemCatalog.propTypes = {}

ItemCatalog.defaultPropTypes = {}

export default ItemCatalog
